import { gql } from "@apollo/client";

const PRO_PLAYER_SEARCH = gql`
  query ProPlayerSearch($query: String!, $count: Int) {
    proPlayerSearch(query: $query, count: $count) {
      id
      name
      avatar
      game
      gameIdentifier
    }
  }
`;

export { PRO_PLAYER_SEARCH };
